import { render, staticRenderFns } from "./CompGamificationRedeemModal.vue?vue&type=template&id=0bd08e0e&scoped=true"
import script from "./CompGamificationRedeemModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGamificationRedeemModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompGamificationRedeemModal.vue?vue&type=style&index=0&id=0bd08e0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd08e0e",
  null
  
)

export default component.exports